import React from "react";
import ReactDOM from "react-dom/client";
import { AdminView } from "./AdminView";
import { RequestForm } from "./RequestForm";
import { ClaimForm } from "./ClaimForm";
import "./index.css";

// This app deliberately does NOT render shared/'s <App /> — that is the
// six-step applicant form, which carries PHI and family data that must never
// reach the Posts who use this app. The claim UI is its own component tree,
// reusing only presentation-level shared pieces.
//
// Routing is a plain pathname switch rather than a router dependency: there are
// three destinations in the finished app (request form, claim page, admin) and
// nothing nested. Add react-router only if that stops being true.

function Root(): React.ReactElement {
  const path = window.location.pathname.replace(/\/+$/, "");
  if (path === "/admin") return <AdminView />;
  // "/claim" is where a magic link lands; the token rides in the query string.
  if (path === "/claim") return <ClaimForm />;
  return <RequestForm />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
